import { Injectable } from '@angular/core';
import {
  Firestore,
  collection,
  collectionData,
  query,
  where,
  addDoc
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Commit } from 'src/app/models/commit';

@Injectable({
  providedIn: 'root'
})
export class CommitService {
  constructor(private firestore: Firestore) {}

  getAllCommit(): Observable<Commit[]> {
    const commitRef = collection(this.firestore, 'commit');
    return collectionData(commitRef, { idField: 'id' }) as Observable<Commit[]>;
  }

  getCommitsByDocument(document: string): Observable<Commit[]> {
    const commitRef = collection(this.firestore, 'commit');
    const q = query(commitRef, where('document', '==', document));
    return collectionData(q, { idField: 'id' }) as Observable<Commit[]>;
  }

  putCommit(commit: Commit): void {
    const commitRef = collection(this.firestore, 'commit');
    addDoc(commitRef, commit).then(() => console.log('Comentario nuevo'));
  }
}
